(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer-utilities"] && !Shopify.designMode) return;
  try {
    
(function () {
  function iniciarFooterCarmellie(footer) {
    if (!footer || footer.dataset.iniciado === 'true') return;

    footer.dataset.iniciado = 'true';

    var botonSubir = footer.querySelector('[data-footer-carmellie-subir]');

    if (botonSubir) {
      botonSubir.addEventListener('click', function () {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      });
    }
  }

  function iniciarTodosLosFootersCarmellie() {
    document.querySelectorAll('[data-footer-carmellie]').forEach(iniciarFooterCarmellie);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciarTodosLosFootersCarmellie);
  } else {
    iniciarTodosLosFootersCarmellie();
  }

  document.addEventListener('shopify:section:load', iniciarTodosLosFootersCarmellie);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-announcements"] && !Shopify.designMode) return;
  try {
    
(function () {
  function iniciarBarraSuperiorEnvio(barra) {
    if (!barra || barra.dataset.iniciada === 'true') return;

    barra.dataset.iniciada = 'true';

    var slides = Array.prototype.slice.call(barra.querySelectorAll('[data-barra-superior-envio-slide]'));
    var botonAnterior = barra.querySelector('[data-barra-superior-envio-anterior]');
    var botonSiguiente = barra.querySelector('[data-barra-superior-envio-siguiente]');
    var autoplayActivo = barra.getAttribute('data-autoplay') === 'true';
    var velocidad = parseInt(barra.getAttribute('data-velocidad'), 10) || 5000;
    var indiceActual = 0;
    var intervalo = null;

    function mostrarSlide(indice) {
      slides.forEach(function (slide, posicion) {
        if (posicion === indice) {
          slide.classList.add('barra-superior-envio__slide--activo');
        } else {
          slide.classList.remove('barra-superior-envio__slide--activo');
        }
      });
    }

    function irSiguiente() {
      if (slides.length <= 1) return;
      indiceActual = (indiceActual + 1) % slides.length;
      mostrarSlide(indiceActual);
    }

    function irAnterior() {
      if (slides.length <= 1) return;
      indiceActual = (indiceActual - 1 + slides.length) % slides.length;
      mostrarSlide(indiceActual);
    }

    function detenerAutoplay() {
      if (intervalo) {
        clearInterval(intervalo);
        intervalo = null;
      }
    }

    function iniciarAutoplay() {
      detenerAutoplay();
      if (autoplayActivo && slides.length > 1) {
        intervalo = setInterval(irSiguiente, velocidad);
      }
    }

    if (botonSiguiente) {
      botonSiguiente.addEventListener('click', function () {
        irSiguiente();
        iniciarAutoplay();
      });
    }

    if (botonAnterior) {
      botonAnterior.addEventListener('click', function () {
        irAnterior();
        iniciarAutoplay();
      });
    }

    barra.addEventListener('mouseenter', detenerAutoplay);
    barra.addEventListener('mouseleave', iniciarAutoplay);

    mostrarSlide(indiceActual);
    iniciarAutoplay();
  }

  function iniciarTodasLasBarrasSuperiorEnvio() {
    document.querySelectorAll('[data-barra-superior-envio]').forEach(iniciarBarraSuperiorEnvio);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciarTodasLasBarrasSuperiorEnvio);
  } else {
    iniciarTodasLasBarrasSuperiorEnvio();
  }

  document.addEventListener('shopify:section:load', iniciarTodasLasBarrasSuperiorEnvio);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
(function () {
  function iniciarHeaderCarmellie(header) {
    if (!header || header.dataset.iniciado === 'true') return;

    header.dataset.iniciado = 'true';

    var abrirBusqueda = header.querySelector('[data-header-carmellie-abrir-busqueda]');
    var cerrarBusqueda = header.querySelector('[data-header-carmellie-cerrar-busqueda]');
    var overlayBusqueda = header.querySelector('[data-header-carmellie-busqueda-overlay]');
    var inputBusqueda = header.querySelector('.header-carmellie__input-busqueda');
    var abrirMenu = header.querySelector('[data-header-carmellie-abrir-menu]');
    var cerrarMenu = header.querySelector('[data-header-carmellie-cerrar-menu]');
    var overlayMenu = header.querySelector('[data-header-carmellie-menu-overlay]');

    function abrirElemento(elemento) {
      if (!elemento) return;
      elemento.hidden = false;
      document.documentElement.style.overflow = 'hidden';
    }

    function cerrarElemento(elemento) {
      if (!elemento) return;
      elemento.hidden = true;
      document.documentElement.style.overflow = '';
    }

    if (abrirBusqueda && overlayBusqueda) {
      abrirBusqueda.addEventListener('click', function () {
        abrirElemento(overlayBusqueda);
        cerrarElemento(overlayMenu);
        setTimeout(function () {
          if (inputBusqueda) inputBusqueda.focus();
        }, 80);
      });
    }

    if (cerrarBusqueda && overlayBusqueda) {
      cerrarBusqueda.addEventListener('click', function () {
        cerrarElemento(overlayBusqueda);
      });
    }

    if (overlayBusqueda) {
      overlayBusqueda.addEventListener('click', function (evento) {
        if (evento.target === overlayBusqueda) {
          cerrarElemento(overlayBusqueda);
        }
      });
    }

    if (abrirMenu && overlayMenu) {
      abrirMenu.addEventListener('click', function () {
        abrirElemento(overlayMenu);
        cerrarElemento(overlayBusqueda);
      });
    }

    if (cerrarMenu && overlayMenu) {
      cerrarMenu.addEventListener('click', function () {
        cerrarElemento(overlayMenu);
      });
    }

    if (overlayMenu) {
      overlayMenu.addEventListener('click', function (evento) {
        if (evento.target === overlayMenu) {
          cerrarElemento(overlayMenu);
        }
      });
    }

    document.addEventListener('keydown', function (evento) {
      if (evento.key === 'Escape') {
        cerrarElemento(overlayBusqueda);
        cerrarElemento(overlayMenu);
      }
    });
  }

  function iniciarTodosLosHeadersCarmellie() {
    document.querySelectorAll('[data-header-carmellie]').forEach(iniciarHeaderCarmellie);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciarTodosLosHeadersCarmellie);
  } else {
    iniciarTodosLosHeadersCarmellie();
  }

  document.addEventListener('shopify:section:load', iniciarTodosLosHeadersCarmellie);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonios-carrusel-horizon"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const iniciarCarruselTestimonios = (contenedor) => {
      const pista = contenedor.querySelector('[data-carrusel-pista]');
      const slides = Array.from(contenedor.querySelectorAll('[data-carrusel-slide]'));
      const puntos = Array.from(contenedor.querySelectorAll('[data-carrusel-punto]'));
      const autoplay = contenedor.dataset.autoplay === 'true';
      const intervalo = Number(contenedor.dataset.intervalo || 5000);
      let indice = 0;
      let temporizador = null;
      let inicioX = 0;
      let diferenciaX = 0;

      if (!pista || slides.length === 0) {
        return;
      }

      const actualizar = (nuevoIndice) => {
        if (nuevoIndice < 0) {
          indice = slides.length - 1;
        } else if (nuevoIndice >= slides.length) {
          indice = 0;
        } else {
          indice = nuevoIndice;
        }

        pista.style.setProperty('transform', `translate3d(-${indice * 100}%, 0, 0)`, 'important');

        puntos.forEach((punto, puntoIndice) => {
          punto.classList.toggle('carrusel-testimonios-horizon__punto--activo', puntoIndice === indice);
        });
      };

      const detener = () => {
        if (temporizador) {
          window.clearInterval(temporizador);
          temporizador = null;
        }
      };

      const iniciar = () => {
        detener();

        if (!autoplay || slides.length <= 1) {
          return;
        }

        temporizador = window.setInterval(() => {
          actualizar(indice + 1);
        }, intervalo);
      };

      contenedor.addEventListener('click', (evento) => {
        const punto = evento.target.closest('[data-carrusel-punto]');
        const anterior = evento.target.closest('[data-carrusel-anterior]');
        const siguiente = evento.target.closest('[data-carrusel-siguiente]');

        if (punto) {
          actualizar(Number(punto.getAttribute('data-carrusel-punto') || 0));
          iniciar();
        }

        if (anterior) {
          actualizar(indice - 1);
          iniciar();
        }

        if (siguiente) {
          actualizar(indice + 1);
          iniciar();
        }
      });

      pista.addEventListener('touchstart', (evento) => {
        inicioX = evento.touches[0].clientX;
        diferenciaX = 0;
        detener();
      }, { passive: true });

      pista.addEventListener('touchmove', (evento) => {
        diferenciaX = evento.touches[0].clientX - inicioX;
      }, { passive: true });

      pista.addEventListener('touchend', () => {
        if (Math.abs(diferenciaX) > 45) {
          if (diferenciaX < 0) {
            actualizar(indice + 1);
          } else {
            actualizar(indice - 1);
          }
        }

        iniciar();
      });

      contenedor.addEventListener('mouseenter', detener);
      contenedor.addEventListener('mouseleave', iniciar);

      actualizar(0);
      iniciar();
    };

    const cargarCarruseles = () => {
      document.querySelectorAll('[data-carrusel-testimonios]').forEach((contenedor) => {
        if (contenedor.dataset.carruselInicializado === 'true') {
          return;
        }

        contenedor.dataset.carruselInicializado = 'true';
        iniciarCarruselTestimonios(contenedor);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', cargarCarruseles);
    } else {
      cargarCarruseles();
    }

    document.addEventListener('shopify:section:load', cargarCarruseles);
  })();

  } catch(e) { console.error(e); }
})();
})();
